var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88583 2H15.4466C18.5642 2 20.3242 3.76825 20.3333 6.88583V15.4475C20.3333 18.5642 18.5642 20.3333 15.4466 20.3333H6.88583C3.76825 20.3333 2 18.5642 2 15.4475V6.88583C2 3.76825 3.76825 2 6.88583 2ZM11.2114 16.5393C11.6065 16.5393 11.9355 16.246 11.9722 15.8518V6.51096C12.0089 6.2268 11.8723 5.94171 11.6248 5.7868C11.3672 5.63096 11.0555 5.63096 10.809 5.7868C10.5605 5.94171 10.424 6.2268 10.4505 6.51096V15.8518C10.4973 16.246 10.8264 16.5393 11.2114 16.5393ZM15.4288 16.5391C15.8138 16.5391 16.1429 16.2458 16.1897 15.8516V12.8449C16.2163 12.5507 16.0797 12.2766 15.8313 12.1208C15.5847 11.9649 15.273 11.9649 15.0163 12.1208C14.7679 12.2766 14.6313 12.5507 14.668 12.8449V15.8516C14.7047 16.2458 15.0338 16.5391 15.4288 16.5391ZM7.701 15.851C7.66433 16.2452 7.33525 16.5385 6.94016 16.5385C6.546 16.5385 6.216 16.2452 6.18025 15.851V9.51682C6.15275 9.23174 6.28933 8.94849 6.53775 8.79266C6.78433 8.63682 7.09691 8.63682 7.34441 8.79266C7.591 8.94849 7.72941 9.23174 7.701 9.51682V15.851Z",
    fill: "#B52126"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.b266a1ad7d58e31f5fd9a82585086d3b.svg";
export { ForwardRef as ReactComponent };